import React from "react";
import ExcalidrawViewer from "../../components/ExcalidrawViewer";

const FoundationOverview: React.FC = () => (
  <ExcalidrawViewer
    filePath="/excalidraw/foundation-overview.excalidraw"
    title="Foundation Package Overview"
    subtitle="What you get with Foundation ($97/mo) -- Tom Miller Services"
  />
);

export default FoundationOverview;
